import { useCallback, useEffect, useRef } from "react";

/**
 * Runs `callback` once, when `isReady` is/becomes `true`
 */
const useRunOnceWhenReady = (callback: () => void, isReady: boolean) => {
  const alreadyRun = useRef(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCallback = useCallback(callback, []);

  useEffect(() => {
    if (!isReady) {
      alreadyRun.current = false;
      return;
    }
    if (alreadyRun.current) return;
    memoizedCallback();
    alreadyRun.current = true;
  }, [isReady, memoizedCallback]);
};

export default useRunOnceWhenReady;
